module.exports = __webpack_public_path__ + "static/media/validacao_celular_dark.446ff649.svg";